import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { scAxiosAdmin } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import RadioGroup from "../RadioGroup";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import thanas from "../../assets/data/thana.json";
import { error } from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import GalleryForEmergency from "./GalleryForEmergency";
import AmbulanceService from "./AmbulanceService";
import AmbulanceGallery from "./AmbulanceGallery";
import { CiLocationOn } from "react-icons/ci";
import { IoCall } from "react-icons/io5";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { isMobile } from "react-device-detect";
const ContactUs = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    phone_number: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [headerData, setHeaderData] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => {
    const headerDataList = {
      ids: [31, 32, 33, 34],
    };
    const getHeaderData = (data) => {
      try {
        const req = scAxiosAdmin
          .post(`/settings/get_multiple`, headerDataList, {
            // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
            method: "get",
            headers: {
              Accept: "application/json",
              // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              // console.log('your log output',data)
              // setStaticPageData(data.data.data);
              setHeaderData(data.data);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getHeaderData();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await scAxiosAdmin.post("/emergenecies_enquiry", {
        type: "contact_us",
        ...formData,
      });
      if (response.status === 201) {
        setLoading(false);
        toast.success("Your inquiry was submitted successfully!");
        // alert("Your inquiry was submitted successfully!");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error submitting inquiry:", error);
      toast.error("Something went wrong!");
    }
  };
  return (
    <div>
      <SEO
        title="Contact Us | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Contact Us"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin">
        <section className="banner-hero">
          <img
            src="/static/media/banner-profile.f160a4c1.jpg"
            alt="banner-profile"
            className="w-100"
          />
        </section>
        <section
          className="prof-dr pb-5"
          style={{ backgroundColor: "#F7F5EF" }}
        >
          <h3
            className="py-5"
            style={{ color: "#AF9763", textAlign: "center" }}
          >
            Contact Us
          </h3>
          <div
            className="container px-0 d-flex flex-column flex-md-row justify-content-between shadow"
            style={{ borderRadius: "18px", backgroundColor: "#ffffff" }}
          >
            <div className={`${isMobile ? "w-100" : "w-50"}`}>
              {/* Contact Form */}
              <div className="pt-5">
                <form onSubmit={handleSubmit} className="p-4">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      Phone
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      name="phone_number"
                      value={formData.phone_number}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <textarea
                      className="form-control"
                      id="message"
                      name="message"
                      rows="4"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="w-100 rounded-3 fw-bold d-flex justify-content-center align-items-center gap-2"
                    style={{
                      backgroundColor: "#F58220",
                      color: "white",
                      borderRadius: "10px",
                      border: "none",
                      padding: "10px",
                    }}
                  >
                    {loading && (
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    )}
                    Submit
                  </button>
                </form>
                <div
                  className="p-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* First Section: Headphone Icon */}
                  <div className="d-flex align-items-center mb-3">
                    <TfiHeadphoneAlt color="#F58220" className="locationIcon" />
                  </div>

                  {/* Second Section: Call Icon and Number */}
                  <a className="text-decoration-none" href="tel:10666">
                    <div className="d-flex align-items-center mb-3">
                      <IoCall
                        size={40}
                        color="#F58220"
                        className="header-text me-2"
                      />
                      <h5 className="header-text" style={{ color: "#F58220" }}>
                        {headerData.length > 0 && headerData[0].value
                          ? headerData[0].value
                          : "10666"}
                      </h5>
                    </div>
                  </a>

                  {/* Third Section: Cell and International Numbers */}
                  <div
                    className="d-flex flex-column flex-xl-row mb-3 justify-content-center align-items-center gap-3 flex-wrap"
                    style={{ color: "#F58220" }}
                  >
                    <h6
                      className="d-flex align-items-center fw-bold"
                      style={{ width: "fit-content", display: "inline-block" }}
                    >
                      Cell:{" "}
                      <span className=" mt-1">
                        {headerData.length > 0 && headerData[1].value
                          ? headerData[1].value
                          : "+880 1914 001234"}
                      </span>{" "}
                    </h6>

                    <h6
                      className=" d-flex align-items-center fw-bold"
                      style={{ width: "fit-content", display: "inline-block" }}
                    >
                      International:{" "}
                      <span className=" mt-1">
                        {headerData.length > 0 && headerData[2].value
                          ? headerData[2].value
                          : "+880 2-2222-62466"}
                      </span>{" "}
                    </h6>
                    <div className="d-flex justify-content-center align-items-center fw-bold">
                      <h6 className=" fw-bold">WhatsApp:</h6>

                      <h6 className=" fw-bold mt-2">
                        {headerData.length > 0 && headerData[3].value
                          ? headerData[3].value
                          : "+880191-4001214"}
                      </h6>
                    </div>
                  </div>

                  {/* Fourth Section: Repeated Cell and International Numbers */}
                </div>
              </div>
            </div>
            <div className={`${isMobile ? "w-100" : "w-50"} d-none d-md-block`}>
              <img
                style={{ objectFit: "cover" }}
                className="w-100 h-100 img-fluid"
                src="/assets/images/uhl_contact.png"
                alt=""
                srcset=""
              />
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default ContactUs;



// WEBPACK FOOTER //
// ./src/component/frontend/ContactUs.js